import { render, staticRenderFns } from "./SemPermissao.vue?vue&type=template&id=0d4bba9a&"
import script from "./SemPermissao.vue?vue&type=script&lang=js&"
export * from "./SemPermissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports